import React, { useEffect } from 'react';
import { Navigate } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import LoadingSpinner from './LoadingSpinner';
import { setLoading, signUpSuccess } from '../../features/authSlice';
import { getMeUser } from '../../api/authApi';
import { showNotification } from './Notification/ToastifyNotification';
import PersistentDrawerLeft from './Sidebar';

const AdminPrivateRoute = ({ children }) => {
  const { loading } = useSelector((state) => state.auth);
  const dispatch = useDispatch();

  const getUser = async () => {
    try {
      const response = await getMeUser();
      if (response.data?.user_id) {
        dispatch(signUpSuccess({
          user: response.data
        }));
        dispatch(setLoading({
          loading: false
        }));
      }
    } catch (err) {
      const errorMessage = err.response?.data?.errors?.[0]?.message || err.response?.data?.message || err?.response?.data?.error;
      dispatch(setLoading({
        loading: false
      }));
      showNotification(errorMessage, 'error');
    }
  }

  useEffect(() => {
    if (localStorage.getItem('token')) {
      dispatch(setLoading({
        loading: true
      }));
      getUser();
    }
  }, [localStorage.getItem('token')]);

  // Redirect to login if not authenticated
  if (!localStorage.getItem('token')) {
    return <Navigate to="/admin" replace />;
  }

  // Render children if authenticated
  return <>
    {loading && (
      <LoadingSpinner />
    )}
    <PersistentDrawerLeft children={children}/>
  </>;
};

export default AdminPrivateRoute;